declare function require(module: string): any;
declare const process: { env: { PARTNER: string } };

import '@dojo/framework/shim/browser';
import global from '@dojo/framework/shim/global';
import { LccApp, onlineChange, registry } from '@holmescorp/lcc-app';
import { themeContext } from '@holmescorp/lcc-state';
import { siteInit } from '@holmescorp/site-init';
import { includes } from 'lodash-es';
import 'moment/locale/es';
import 'moment/locale/fr';
import ResizeObserver from 'resize-observer-polyfill';
import 'tslib';
import './has-setup';

const { register_lp_widgets, setup_actions } = require(`./${process.env.PARTNER}/init/main`);
const themeModule = require(`./${process.env.PARTNER}/theme/theme`);
const { microSites, sideEffects } = require(`../partners/${process.env.PARTNER}`);

if (sideEffects) {
	sideEffects();
}

if (!global.ResizeObserver) {
	global.ResizeObserver = ResizeObserver;
}

const site = (window as any).hcstatic.portal_site;
const isMicro = microSites ? includes(microSites, site) : false;
const theme = isMicro && themeModule.microTheme ? themeModule.microTheme : themeModule.default;
themeContext.set(theme, site);

register_lp_widgets();
setup_actions();

siteInit(LccApp, registry, onlineChange);
